import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getter from './getter'
import actions from './actions'

Vue.use(Vuex)
const store = new Vuex.Store({
	state:{
		isTheEighth:true,	//是否第八届（第八届  首页才有上报材料按钮）
		debug:false,
		apiUrl:'',
		//apiUrl:'http://117.78.45.46',
		token:'',
		nowRouteName:'',	//当前路由名称
		isMobile:false,	//是否移动端
		winW:0,		//浏览器高度
		winH:0,		//浏览器高度
		//bannerShow:true,//右侧banner是否显示
		navData:null,	//导航列表
		nowNavId:'',
		lan:'en',
		otherData:null,	//其他一些配置
		friendLink:null,	//友情链接
	},
	mutations,
	getter,
	actions
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js